import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import Button from './Button'
import localize from '@/i18n/translate'
// import classNames from '@/helpers/classNames'

const EditButton = ({
  source,
  basePath = '',
  title = 'i18n.action.edit',
  record = {},
  clean = false,
  locale,
  translate,
  sortable,
  click,
  label,
  ...rest
}) => (
  <Button
    {...rest}
    classes={clean ? 'secondary' : ['clean', 'link']}
    {...click && { onClick: e => click(record) }}
  >
    <Choose>
      <When condition={title}>{translate(title)}</When>
      <When condition={source}>{get(record, source)}</When>
    </Choose>
  </Button>
)

EditButton.propTypes = {
  label: PropTypes.string,
  locale: PropTypes.any,
  sortable: PropTypes.bool,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired,
}

export default localize(EditButton)



// WEBPACK FOOTER //
// ./ui/Button/EditButton.js